import React, { useState } from "react";
import "../Search/style.css";

const Search = ({ handleSearch, resetSearch }) => {
  const [input, setInput] = useState("");
  return (
    <nav className="ladder-nav">
      <input
        type="text"
        className="live-search-box"
        placeholder="Search Your Name"
        onChange={(event) => setInput(event.target.value)}
        value={input}
      />
      <button
        className={`search-button ${input ? '' : 'disabled'}`}
        type="submit"
        onClick={() => handleSearch(input)}
        disabled={input ? false : true}
        
      >
        Search
      </button>
      <button
        className={`search-button-reset ${input ? '' : 'disabled'}`}
        type="submit"
        onClick={() => {
          setInput("");
          resetSearch();
        }}
        disabled={input ? false : true}
        
      >
        Reset
      </button>
    </nav>
  );
};

export default Search;
